<template>
  <div>
      <v-container>

        <v-row>
            <v-col cols="8" offset="2">

            <v-expansion-panels>
                <v-expansion-panel>
                    <v-expansion-panel-header style="background-color:#E4CFA6">Envíos y Devoluciones</v-expansion-panel-header>
                    <v-expansion-panel-content class="pr-2 py-4">
                        <p style="white-space: pre-wrap;">
                        {{legales.envios}}
                        </p>
                    </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel class="mt-4">
                    <v-expansion-panel-header style="background-color:#E4CFA6">Términos y Condiciones</v-expansion-panel-header>
                    <v-expansion-panel-content class="pr-2 py-4">
                        <p style="white-space: pre-wrap;">
                        {{legales.terminos}}
                        </p>
                    </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel class="mt-4">
                    <v-expansion-panel-header style="background-color:#E4CFA6">Aviso de Privacidad</v-expansion-panel-header>
                    <v-expansion-panel-content class="pr-2 py-4">
                        <p style="white-space: pre-wrap;">
                            {{legales.aviso_privacidad}}
                        </p>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
            </v-col>
        </v-row>
      </v-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      items: [
        {
          text: "Inicio",
          disabled: false,
          href: "/"
        },
        {
          text: "Eventos",
          disabled: true
        }
      ],
      legales: {
        envios: "",
        terminos: "",
        aviso_privacidad: ""
      }
    };
  },
  created: function() {
    fetch(
      "https://flordeazaharcms.actstudio.xyz/api/singletons/get/Terminos?token=bd38a532024ddfd195a5fdefd8eb98"
    )
      .then(res => res.json())
      .then(res => (this.legales = res));
  }
};
</script>